// extracted by mini-css-extract-plugin
module.exports = {"box":"Page3_box__2s3W9","qrIcon":"Page3_qrIcon__1qYaT","middleLine":"Page3_middleLine__2QRvZ","Text":"Page3_Text__3j-m8"};